/* esm.sh - @floating-ui/core@1.7.5 */
export * from "/*@floating-ui/core@1.7.5/esnext/core.mjs";
